export default __webpack_public_path__ + "static/media/a020-it-2.23d9a3bf.svg";